import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PopComponent } from './pop.component';
import { PopContentComponent } from './pop-content.component';
import { PopService } from './pop.service';
import { DynamicPopTriggerDirective } from './dynamic-pop-trigger.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        PopComponent,
        PopContentComponent,
        DynamicPopTriggerDirective
    ],
    exports: [
        PopComponent,
        DynamicPopTriggerDirective
    ],
    providers: [
        PopService
    ]
})

export class PopComponentModule {}
